import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import app from './app/AppReducer';
import main from './main/MainReducer';
import hero from './main/HeroReducer';
import menu from './header/menu/MenuReducer';
import gallery from './gallery/GalleryReducer';
import map from './map/MapReducer';
import threeDModel from './threeDModel/ThreeDModelReducer';
import video from './video/VideoReducer';
import matterport from './matterport/MatterportReducer';
import floorplan from './floorplan/FloorplanReducer';
import agent from './agent/AgentReducer';
import listings from './listings/ListingsReducer';
import modals from './modals/ModalsReducer';
import footer from './footer/FooterReducer';

import * as appConsts from './app/AppConsts';
import { MAP_TYPES } from './map/MapConsts';

const appReducer = combineReducers({
    app,
    main,
    hero,
    menu,
    agent,
    gallery,
    map,
    video,
    matterport,
    floorplan,
    footer,
    listings,
    threeDModel,
    modals,
    routing: routerReducer
});

const rootReducer = (state, action) => {

    const getInitialImage = (stages) => {
        if (stages.length && stages[0].markers[0]) {
            const initialIndex = stages[0].beginning
                ? stages[0].beginning
                : 0;
            return stages[0].markers[initialIndex].file_name;
        }
        return '';
    }

    const getThreeDModelUrl = (data) => {
        if (data.sd_project_key && data.sd_project_key.length) {
            return data.sd_project_key;
        }

        if (data.floorplanner_project_id && data.floorplanner_project_id.length) {
            return data.floorplanner_project_id;
        }

        return '';
    }

    const getFloorplanData = (floorplan) => {
        if (!floorplan) {
            return {
                ...state.floorplan
            }
        }

        return {
            ...state.floorplan,
            imagesPath: floorplan.base_path,
            stages: floorplan.stages,
            activeSlideName: getInitialImage(floorplan.stages)
        }
    }

    const getClaimHomeLink = (url) => {
        if (!url) {
            return null;
        }

        const tourId = state.app.tourId;
        const cr = encodeURIComponent(document.location.origin);
        const mode = state.app.tourType;
        const link = `${url}${tourId}/${cr}/${mode}`;

        return link;
    }

    switch (action.type) {
        case appConsts.GET_TOUR_FULFILLED:
            const data = action.payload;
            return {
                ...state,
                app: {
                    ...state.app,
                    getTourFulfilled: true,
                    isDrafted: !!+data.is_draft,
                    isLogined: data.is_logined,
                    tourMode: new URL(window.location.href).pathname.split('/').pop(),
                    reCaptcha_key: data.reCaptcha_key
                },
                main: {
                    ...state.main,
                    address: {
                        ...state.main.address,
                        full: data.address,
                        city: data.city,
                        state: data.state,
                        street: data.street,
                        zip: data.zip
                    },
                    price: {
                        ...state.main.price,
                        type: data.propertyInfo.price.type,
                        value: parseFloat(data.propertyInfo.price.value),
                        from: parseFloat(data.propertyInfo.price.from_value),
                        to: parseFloat(data.propertyInfo.price.to_value)
                    },
                    sqft: {
                        ...state.main.sqft,
                        type: data.propertyInfo.sqft.type,
                        value: parseFloat(data.propertyInfo.sqft.value),
                        from: parseFloat(data.propertyInfo.sqft.from_value),
                        to: parseFloat(data.propertyInfo.sqft.to_value)
                    },
                    description: data.description,
                    descriptionPlain: data.description_plain,
                    title: data.tour_title,
                    lotSize: data.propertyInfo.lot_size,
                    bathsAll: parseFloat(data.propertyInfo.num_of_all_baths),
                    baths: parseFloat(data.propertyInfo.num_of_baths),
                    halfBath: parseFloat(data.propertyInfo.num_of_half_baths),
                    twoThirdBaths: parseFloat(data.propertyInfo.num_of_two_thirds_baths),
                    quarterBaths: parseFloat(data.propertyInfo.num_of_quarter_baths),
                    bedrooms: parseInt(data.propertyInfo.num_of_bedrooms),
                    listingId: data.mls_id,
                    listingType: data.propertyInfo.listing_type,
                    listingStatus: data.listing_status,
                    listingPricePeriod: data.listing_price_period,
                    listingPricePeriodFrom: data.listing_price_period_from,
                    listingPricePeriodTo: data.listing_price_period_to,
                    propertyType: data.propertyInfo.property_type,
                    basementType: data.propertyInfo.basement_type,
                    garageBays: parseFloat(data.propertyInfo.num_of_garage_bays),
                    additionalGarageBays: data.propertyInfo.num_of_add_garage_bays,
                    floorsAboveGround: parseFloat(data.propertyInfo.num_of_floors_above_ground),
                    photoСount: data.photo_count,
                    features: {
                        ...state.main.features,
                        exterior: data.propertyFeatures.exterior,
                        interior:data.propertyFeatures.interior
                    },
                    documents: data.documents,
                    dashboard: data.dashboard,
                    yearBuilt: data.propertyInfo.year_built,
                },
                hero: {
                    ...state.hero,
                    yearBuilt: data.heroInfo.year_built,
                    bedrooms: parseFloat(data.heroInfo.num_of_bedrooms),
                    baths: parseFloat(data.heroInfo.num_of_baths),
                    bathsAll: parseFloat(data.heroInfo.num_of_all_baths),
                    halfBath: parseFloat(data.heroInfo.num_of_half_baths),
                    garageBays: parseFloat(data.heroInfo.num_of_add_garage_bays),
                    lotSize: data.heroInfo.lot_size,
                    price: {
                        ...state.hero.price,
                        type: data.heroInfo.price.type,
                        value: parseFloat(data.heroInfo.price.value),
                        from: parseFloat(data.heroInfo.price.from_value),
                        to: parseFloat(data.heroInfo.price.to_value)
                    },
                    sqft: {
                        ...state.hero.sqft,
                        type: data.heroInfo.sqft.type,
                        value: parseFloat(data.heroInfo.sqft.value),
                        from: parseFloat(data.heroInfo.sqft.from_value),
                        to: parseFloat(data.heroInfo.sqft.to_value)
                    },
                },
                menu: {
                    ...state.menu,
                    buttonsParams: {
                        ...state.menu.buttonsParams,
                        visibility: {
                            ...state.menu.visibility,
                            threeDModelBtnVisible: !!+getThreeDModelUrl(data).length,
                            floorplanBtnVisible: !!data.floorplan,
                            matterportBtnVisible: !!+data.matterport.data.length,
                            videoBtnVisible: !!+data.videos.data.length,
                            mapBtnVisible: !!+data.buttons_state.media_amap,
                            shareBtnVisible: !!+data.buttons_state.tools_bookmarks,
                            walkthruBtnVisible: !!+data.walkthru_video.length,
                            infoBtnVisible: !!+data.buttons_state.showFeatures || !!data.documents.length || !!data.description,
                            pinfoBtnVisible: !!+data.buttons_state.tools_contact,
                            claimHomeBtnVisibility: !!data.claim_url,
                            showFeatures: !!+data.buttons_state.showFeatures
                        },
                        defaultButton: data.show_by_default,
                        titles: {
                            ...state.menu.buttonsParams.titles,
                            matterportBtnTitle: data.matterport.title,
                            threeDModelBtnTitle: data.buttons_state.media_floorplanner_button_name
                        },
                        links: {
                            claimHomeBtnLink: getClaimHomeLink(data.claim_url),
                        }
                    }
                },
                agent: {
                    agentInfo: {
                        id: parseInt(data.agent.member_id),
                        name: data.agent.name,
                        company: data.agent.company,
                        phone: data.agent.phone,
                        mobilePhone: data.agent.mobile_phone,
                        businessPhone: data.agent.business_phone,
                        fax: data.agent.fax,
                        title: data.agent.title,
                        designations: data.agent.designations,
                        license_number: data.agent.license_number,
                        email: data.agent.email,
                        website: data.agent.website,
                        orig_website: data.agent.orig_website,
                        logo: data.agent.logo,
                        logoTime: data.S3Information.logoTime,
                        photoTime: data.S3Information.photoTime,
                        photo: data.agent.photo,
                        address: data.agent.agent_company_address,
                        showFpoBrand: data.show_fpo_brand
                    },
                    colisterInfo: {
                        id: parseInt(data.colisterInfo.member_id),
                        name: data.colisterInfo.name || '',
                        company: data.colisterInfo.company || '',
                        phone: data.colisterInfo.phone || '',
                        mobilePhone: data.colisterInfo.mobile_phone || '',
                        businessPhone: data.colisterInfo.business_phone || '',
                        fax: data.colisterInfo.fax || '',
                        title: data.colisterInfo.title || '',
                        designations: data.colisterInfo.designations || '',
                        license_number: data.colisterInfo.license_number || '',
                        email: data.colisterInfo.email || '',
                        website: data.colisterInfo.website || '',
                        orig_website: data.colisterInfo.orig_website || '',
                        logo: data.colisterInfo.logo || '',
                        photo: data.colisterInfo.photo || '',
                        address: data.colisterInfo.agent_company_address || ''
                    }
                },
                map: {
                    ...state.map,
                    location: {
                        ...state.map.location,
                        lat: parseFloat(data.map && data.map.location.lat) ? parseFloat(data.map.location.lat) : 0,
                        lng: parseFloat(data.map && data.map.location.lon) ? parseFloat(data.map.location.lon) : 0
                    },
                    mapInfo: {
                        ...state.map.mapInfo,
                        zoom: data.map ? parseFloat(data.map.mapInfo.map_zoom_level) : 0,
                        type: data.map ? MAP_TYPES[data.map.mapInfo.type ? data.map.mapInfo.type : 2] : 2,
                        defaultStreetView: data.map ? !!+data.map.mapInfo.defaultStreetView : true
                    }
                },
                video: {
                    ...state.video,
                    videos: data.videos.data,
                    videoType: data.videos.type,
                    embedTitle: data.videos.title,
                    walkthruVideo: data.walkthru_video || '',
                    walkthruStatus: data.walkthru_video_status
                },
                matterport: {
                    ...state.matterport,
                    matterport: data.matterport.data,
                    matterportType: data.matterport.type
                },
                floorplan: getFloorplanData(data.floorplan),
                threeDModel: {
                    ...state.threeDModel,
                    url: getThreeDModelUrl(data)
                },
                modals: {
                    ...state.modals,
                    modalDraftIsOpen: !!+data.is_draft
                },
                gallery: {
                    ...state.gallery,
                    galleryExists:!!+data.photo_count
                },
                footer: {
                    ...state.footer,
                    disclaimer: data.disclaimer.text,
                    poweredBy: {
                        ...state.footer.poweredBy,
                        company: data.powered_by_logo.company,
                        url: data.powered_by_logo.url
                    },
                    localCompany: {
                        ...state.footer.localCompany,
                        company: data.orderBottomLogo.company,
                        url: data.orderBottomLogo.url
                    }

                }
            }

            case appConsts.POST_MESSAGE_EVENT:
                return {
                    ...state,
                    app: {
                        ...state.app,
                        // theme: action.payload.theme || state.app.theme,
                        // backgroundPhoto: {
                        //     ...state.app.backgroundPhoto,
                        //     file_name: action.payload.file_name || state.app.backgroundPhoto.file_name
                        // }
                    },

                    main: {
                        ...state.main,
                        title: action.payload.title || state.main.title,
                        listingStatus: action.payload.listingStatus === undefined ? state.main.listingStatus : action.payload.listingStatus,
                        description: action.payload.description || state.main.description,
                        backgroundPhoto: {
                            ...state.main.backgroundPhoto,
                            file_name: action.payload.file_name || state.main.backgroundPhoto.file_name
                        },
                        dashboard: action.payload.dashboard || state.main.dashboard,
                        price: action.payload.price !== undefined ? action.payload.price : state.main.price,
                        sqft: action.payload.sqft !== undefined ? action.payload.sqft : state.main.sqft,
                        bedrooms: action.payload.bedrooms !== undefined ? action.payload.bedrooms : state.main.bedrooms,
                        baths: action.payload.baths !== undefined ? action.payload.baths : state.main.baths,
                        lotSize: action.payload.lotSize !== undefined ? action.payload.lotSize : state.main.lotSize,
                        halfBath: action.payload.halfBath !== undefined ? action.payload.halfBath : state.main.halfBath,
                    }

            }

        default:
            break;
    }

    if (action.type === '') {
        console.log(action.payload);
    }
    return appReducer(state, action)
}

export default rootReducer;
